<template>
<div class="page-content">

    <SeoMeta v-if="pageContent"
        :title="'TheJobTap.com - ' + pageContent.Headline" 
        :description=pageContent.Meta
    />
    
  <section class="pt-28 lg:pt-44 pb-28 group-data-[theme-color=violet]:bg-violet-500 group-data-[theme-color=sky]:bg-sky-500 group-data-[theme-color=red]:bg-red-500 group-data-[theme-color=green]:bg-green-500 group-data-[theme-color=pink]:bg-pink-500 group-data-[theme-color=blue]:bg-blue-500 dark:bg-neutral-900 bg-[url('../images/home/page-title.png')] bg-center bg-cover relative" >
      <div class="container mx-auto">
          <div class="grid">
              <div class="col-span-12">
                  <div class="text-center text-white" v-if="pageContent">
                      <h1 class="mb-4 text-[26px]">{{ pageContent?.Header }}</h1>
                      <div class="page-next">
                        <p>{{ pageContent.Headline }}</p>
                      </div>
                  </div>
              </div>
          </div>
      </div>

      <img rel="prefetch" src="@/assets/images/about/shape.png" alt="header image" class="absolute block bg-cover -bottom-0 dark:hidden" style="width: 100%;">
      <img rel="prefetch" src="@/assets/images/about/shape-dark.png" alt="header image dark" class="absolute hidden bg-cover -bottom-0 dark:block" style="width: 100%;">
    </section>

  <section class="py-12">
        <div class="container mx-auto">
          <div v-if="pageContentFound == null" style="margin-bottom: 300px;">
              <Loader />
            </div> 
            <div v-else-if="pageContentFound == false">
                <!-- <p>not found</p> -->
            </div>
    <div v-else class="grid grid-cols-12 gap-y-5 lg:gap-5 lg:items-center">
            <div class="col-span-12 items-center" v-if="pageContentFound == true">
              <h3 style="" class="w-full text-gray-800 mb-5 dark:text-gray-300 ">{{ pageContent.Title }}</h3> 
              <div class="flex items-center text-gray-500">
                <div class="flex-shrink-0 ltr:mr-3 rtl:ml-3">
                    <img v-lazy="pageContent.MainImage"  class="w-30 h-24" :alt="pageContent.Title">
                </div>
                <div style="margin-left: 5px; max-width: 900px; ">
                  <!-- <h3 style="" class="mb-0 dark:text-gray-300 hidden sm:block ">{{ pageContent.Title }}</h3>  -->
                  <p style="color: rgb(116 120 141 / var(--tw-text-opacity)) !important;
                            --tw-text-opacity: 1 !important;
                            font-family: Inter, sans-serif;
                            font-size: 14px;
                            max-width: 650px;">
                            {{ pageContent.Meta }}</p>
                </div>
              </div>
      </div>

      <div class="col-span-12 lg:col-span-8 mb-5">
              <!-- LandingPage: Content -->
              <WysiwygViewer class="text-gray-900 dark:text-gray-50" :viewerText="this.pageContent.Content" />
        </div>
                
        <div class="col-span-12 lg:col-span-4" style="padding-left: 5px; padding-right: 5px;">
            <div class="border rounded border-gray-100/50 dark:border-neutral-600">
                <div class="p-5 border-b border-gray-100/50 dark:border-neutral-600" style="min-height: 250px;">
                    <div class="text-center">
                    <p class="text-gray-500 dark:text-gray-300 text-center mb-5" ><b>Combine your skills and search jobs like this</b></p>
                    <multiselect 
                        class="filter-job-input-box-custom"
                        v-model="this.search.tags" 
                        :options="options" 
                        :searchable="false" 
                        :multiple="true" 
                        :close-on-select="false" 
                        :clear-on-select="true"              
                        :preserve-search="false" 
                        placeholder="Select skills" 
                        :select-label="'Tap to select'"
                        :deselect-label="'Tap to remove'"
                        label="" 
                        track-by="" 
                        :preselect-first="false">
                        <template #selection="{ values, isOpen }" 
                        >
                            <span class="multiselect__single filter-job-input-box-custom dark:text-gray-200 "
                                v-if="values.length"
                                v-show="!isOpen">
                                {{ values.length }} skills selected: 
                                <ul class="flex flex-wrap gap-2 mt-2 ">
                                    <li 
                                        class="border p-[6px] border-gray-100/50 rounded group/joblist dark:border-gray-100/20 active"
                                        v-bind:key="tag" 
                                        v-for="tag in this.search.tags" >
                                        <div class="flex items-center ">
                                          <a href="javascript:void(0)" 
                                              class="dark:border-gray-100/20">
                                              <h6 class="mb-0 transition-all duration-300 fs-14 group-data-[theme-color=violet]:group-hover/joblist:text-violet-500 group-data-[theme-color=sky]:group-hover/joblist:text-sky-500 group-data-[theme-color=red]:group-hover/joblist:text-red-500 group-data-[theme-color=green]:group-hover/joblist:text-green-500 group-data-[theme-color=pink]:group-hover/joblist:text-pink-500 group-data-[theme-color=blue]:group-hover/joblist:text-blue-500">
                                                {{ tag }}
                                              </h6>
                                          </a>
                                        </div>
                                    </li>
                                </ul>
                            </span>
                        </template>
                    </multiselect>
                    <!-- Search: Remote selection -->
                    <div class="mt-3 filter-search-form mt-lg-0">
                      <i class="uil uil-clipboard-notes"></i>
                      <select v-model="this.search.workingStyle" class="w-full filter-job-input-box dark:text-gray-100">
                          <option value="NotSet">Working style</option>
                          <option value="Remote">Remote</option>
                          <option value="Hybrid">Hybrid</option>
                          <option value="Office">Office</option>
                      </select>
                    </div>
                    <!-- Search: Contract Type selection -->
                    <div class="mt-3 filter-search-form mt-lg-0">
                      <i class="uil uil-clipboard-notes"></i>
                      <select v-model="this.search.contractType" class="w-full filter-job-input-box dark:text-gray-100">
                          <option value="NotSet">Contract type</option>
                          <option value="Contract">Contract</option>
                          <option value="Internship">Internship</option>
                          <option value="Full-time">Full-time</option>
                          <option value="Part-time">Part-time</option>
                      </select>
                    </div>
                    <br>
                    <button @click.stop="searchClickHandle" class="text-white border-transparent group-data-[theme-color=violet]:bg-violet-500 group-data-[theme-color=sky]:bg-sky-500 group-data-[theme-color=red]:bg-red-500 group-data-[theme-color=green]:bg-green-500 group-data-[theme-color=pink]:bg-pink-500 group-data-[theme-color=blue]:bg-blue-500 btn hover:-translate-y-2">Search <i class="align-middle uil uil-rocket ms-1"></i></button>
                    </div>
                </div>
            </div>
        </div>

            </div>
        </div>
    </section>

    <LandingJobListingSearchResult v-if="pageContent"
      :tags= this.pageContent.CategoryNames
      :attendanceRequirement = this.pageContent.WorkingStyle
      :contractType = this.pageContent.ContractType>
      </LandingJobListingSearchResult>

    <RelatedArticles v-if="pageContent"                   
      :tags= this.pageContent.CategoryNames>
    </RelatedArticles>

    <section class="bg-gray-50 dark:bg-neutral-700" style="padding-top: 40px;" v-if="pageContent != null && pageContent.FAQS != null">
        <div class="container mx-auto">
            <div class="grid grid-cols-1 gap-5">
                <div class="mb-5 text-center">
                    <h3 class="mb-3 text-3xl text-gray-900 dark:text-gray-50">Frequently Asked Questions</h3>
                    <p class="mb-5 text-gray-500 whitespace-pre-line dark:text-gray-300">If you're exploring a career with skills in {{ pageContent.CategoryNames.join(', ') }}, you may have questions about the skills required, the types of roles available, and remote work opportunities. 
                      Below are some of the most common FAQs to help you better understand the {{ pageContent.CategoryName }} job landscape and how to position yourself for success.</p>
                </div>
            </div>
            <div class="grid grid-cols-12 gap-5">
                <div class="col-span-12 md:col-span-12 lg:col-span-12 ">
                    <!-- Frequently Asked Questions -->
                    <div  style="margin-bottom: 60px">
                        <div class="accordion" style="max-width:800px" v-if="pageContent.FAQS">
                          <details class="dark:bg-neutral-700">
                              <summary class="text-gray-500 dark:text-gray-300">{{ pageContent.FAQS.Question1.Question }}</summary>
                              <p class="text-gray-400 dark:text-white">{{ pageContent.FAQS.Question1.Answer }}</p>
                          </details>
                          <details class="dark:bg-neutral-700" v-if="pageContent.FAQS.Question3">
                              <summary class="text-gray-500 dark:text-gray-300">{{ pageContent.FAQS.Question2.Question }}</summary>
                              <p class="text-gray-400 dark:text-white">{{ pageContent.FAQS.Question2.Answer }}</p>
                          </details>
                          <details class="dark:bg-neutral-700" v-if="pageContent.FAQS.Question3">
                              <summary class="text-gray-500 dark:text-gray-300">{{ pageContent.FAQS.Question3.Question }}</summary>
                              <p class="text-gray-400 dark:text-white">{{ pageContent.FAQS.Question3.Answer }}</p>
                          </details>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

  </div>

</template>
<script>

import { siteAPI } from "@/api/site";
import { useStatus } from "@/api/composables/status";
import { useErrorLogger } from "@/api/composables/errorLogging";
import EmailSubscriptionForm from "@/components/Forms/EmailSubscriptionForm.vue";
import FeedbackNotification from "@/components/FeedbackNotification.vue";
import WysiwygViewer from '@/components/WysiwygViewer.vue'
import { jobListingCategoryAPI } from "@/api/jobListingCategory";
import Multiselect from 'vue-multiselect'
import Loader from "@/components/Loader.vue";
import LandingJobListingSearchResult from "@/components/JobListingSearchResults/LandingJobListingSearchResult.vue";
import RelatedArticles from "@/components/RelatedArticles.vue";
import SeoMeta from "@/components/Seo/SeoMeta.vue";

const pageStatus = useStatus();
const log = useErrorLogger();

  export default{
    name: "LandingPage",
    components : {
      EmailSubscriptionForm, FeedbackNotification, WysiwygViewer, Multiselect, Loader, LandingJobListingSearchResult, RelatedArticles, SeoMeta
  }, 
  data() {
    return {
      notification : {
        text : "",
        level : "",
      },
      search: {
        tags: [],
        workingStyle: "NotSet",
        contractType: "NotSet",
      },
      pageContent : null,
      pageContentFound: null,
      options: []
    }
  },
  watch:{
    $route (to, from){
        this.getLandingPage();
        this.getJobListingCategories();
    }
  },
  created()
  {
    this.getLandingPage();
    this.getJobListingCategories();
  },
  mounted() {
    
  },
  methods: {
  async getLandingPage() {
      const result = await log.catchPromise(() =>
        pageStatus.observe(async () => {
          const result = await siteAPI.getLandingPage(this.$route.params.slug);

          if (result.data == null)
          {
            this.pageContentFound = false;
            this.$router.push('/404/');
          }
          else
          {
            this.pageContentFound = true;
            this.pageContent = result.data;
            document.title = this.pageContent.Title + ' - TheJobTap.com';
            this.search.tags = this.pageContent.CategoryNames;
            this.search.contractType = this.pageContent.ContractType;
            this.search.workingStyle = this.pageContent.WorkingStyle;
          }
        })
      );
      if (!result.success) {
        this.notification = { text : result.data, level : "error" };        
      }
    },
    async getJobListingCategories() {
      const result = await log.catchPromise(() =>
        pageStatus.observe(async () => {
          const result = await jobListingCategoryAPI.getCategories();
          result.forEach((element) => { 
            this.options.push(element.Name);
          });
        })
      );
      if (!result.success) {
        this.notification = { text : result.data, level : "error" };        
      }
    },
    async searchClickHandle() {
      var queryString = "";
      if(this.search.tags.length > 0)
      {
        var isFirst = true;
        this.search.tags.forEach(element => {
          if (element != '')
          {
            if(isFirst)
            {
                isFirst = false;
                queryString = queryString + "tags=" + encodeURIComponent(element);
            }
            else
            {
                queryString = queryString + "&tags=" + encodeURIComponent(element);
            }
          }
        });
      } 
      if (this.search.workingStyle != null && this.search.workingStyle != 'NotSet')
      {
            queryString = queryString + "&workingStyle=" + this.search.workingStyle;
      }
      
      if(this.search.contractType != null && this.search.contractType != 'NotSet')
      {
            queryString = queryString + "&contractType=" + this.search.contractType;
      }
  
      if(queryString != "")   {
        queryString = "?" + queryString;
      }     
      await this.$router.push('/' + queryString);
    },
  }
};
  </script>